import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthPageLayout from './AuthPageLayout';
import SignUpComponent from './SignUpComponent';

function SignUpPage() {
  const { currentUser } = useAuth();
  const [signupStarted, setSignupStarted] = useState(false);
  if (currentUser && !signupStarted) return <Navigate to="/" />;

  return (
    <AuthPageLayout
      mode="signup"
      eyebrow="START YOUR CLIMBING RÉSUMÉ"
      title="Join ClimberLink"
      description="Create your profile and find the people who belong on your next objective."
    >
      <SignUpComponent onSubmittingChange={setSignupStarted} />
      <p className="auth-switch">Already have an account? <Link to="/login">Welcome back</Link></p>
    </AuthPageLayout>
  );
}

export default SignUpPage;
